import _isEmpty from 'lodash/isEmpty';
import type { NavItems, NavigationItem } from '../types';

type Props = {
  primary: NavigationItem[] | undefined;
  secondary?: NavItems | undefined;
};

// To check if the navigation items are empty
export const getIsNavigationEmpty = ({ primary, secondary }: Props) => {
  return _isEmpty(primary) && _isEmpty(secondary);
};
